import React, { useEffect, useRef, useState } from "react";
import Headerbar from "../../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../../Components/InnerLayout/UserInterface";
import { actions } from "../../../../../Redux";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import DatePicker from "react-datepicker";
import moment from "moment";

const Sales = (params) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const salesData = useSelector((state) => state?.financeReducer?.salesData);

  console.log(salesData?.sales_income, "ppppppp");

  // const sales_income = [
  //   {
  //     date: "First Row",
  //     gross_item_sales: 0,
  //     total_payment: 0,
  //     excess_amount: 0,
  //     discounts: 0,
  //     net_item_sales: 0,
  //     service_charges: 0,
  //     net_sales: 0,
  //     sales_tax: 0,
  //     tips: 0,
  //     refunds: 0,
  //     merchant_id: 1,
  //     parent_merchant_id: 0,
  //     linked_merchant_ids: [1, 13],
  //     account_name: "Group-Jonathan",
  //     account_type: "group",
  //     children: [
  //       {
  //         date: "Second Row",
  //         gross_item_sales: 0,
  //         total_payment: 0,
  //         excess_amount: 0,
  //         discounts: 0,
  //         net_item_sales: 0,
  //         service_charges: 0,
  //         net_sales: 0,
  //         sales_tax: 0,
  //         tips: 0,
  //         refunds: 0,
  //         merchant_id: 1,
  //         parent_merchant_id: 1,
  //         linked_merchant_ids: [1],
  //         account_name: "HQ-Jonathan",
  //         account_type: "hq",
  //         children: [
  //           {
  //             date: "Third Row",
  //             gross_item_sales: 0,
  //             total_payment: 0,
  //             excess_amount: 0,
  //             discounts: 0,
  //             net_item_sales: 0,
  //             service_charges: 0,
  //             net_sales: 0,
  //             sales_tax: 0,
  //             tips: 0,
  //             refunds: 0,
  //             merchant_id: 1,
  //             parent_merchant_id: 1,
  //             linked_merchant_ids: [1],
  //             account_name: "HQ-Jonathan",
  //             account_type: "hq",
  //             children: [],
  //           },
  //         ],
  //       },
  //       {
  //         date: "2022-09-01",
  //         gross_item_sales: 0,
  //         total_payment: 0,
  //         excess_amount: 0,
  //         discounts: 0,
  //         net_item_sales: 0,
  //         service_charges: 0,
  //         net_sales: 0,
  //         sales_tax: 0,
  //         tips: 0,
  //         refunds: 0,
  //         merchant_id: 1,
  //         account_name: "Cluster-North Zone",
  //         parent_merchant_id: 1,
  //         account_type: "cluster",
  //         linked_merchant_ids: [],
  //         children: [],
  //       },
  //       {
  //         date: "2022-09-01",
  //         gross_item_sales: 0,
  //         total_payment: 0,
  //         excess_amount: 0,
  //         discounts: 0,
  //         net_item_sales: 0,
  //         service_charges: 0,
  //         net_sales: 0,
  //         sales_tax: 0,
  //         tips: 0,
  //         refunds: 0,
  //         merchant_id: 1,
  //         account_name: "Cluster-North Zone",
  //         parent_merchant_id: 1,
  //         account_type: "cluster",
  //         linked_merchant_ids: [],
  //         children: [],
  //       },
  //       {
  //         date: "2022-09-01",
  //         gross_item_sales: 0,
  //         total_payment: 0,
  //         excess_amount: 0,
  //         discounts: 0,
  //         net_item_sales: 0,
  //         service_charges: 0,
  //         net_sales: 0,
  //         sales_tax: 0,
  //         tips: 0,
  //         refunds: 0,
  //         merchant_id: 13,
  //         parent_merchant_id: 13,
  //         linked_merchant_ids: [13],
  //         account_name: "Outlet-Jonthan",
  //         account_type: "outlet",
  //         children: [],
  //       },
  //     ],
  //   },
  //   {
  //     date: "2022-09-01",
  //     gross_item_sales: 0,
  //     total_payment: 0,
  //     excess_amount: 0,
  //     discounts: 0,
  //     net_item_sales: 0,
  //     service_charges: 0,
  //     net_sales: 0,
  //     sales_tax: 0,
  //     tips: 0,
  //     refunds: 0,
  //     merchant_id: 1,
  //     parent_merchant_id: 0,
  //     linked_merchant_ids: [1, 13],
  //     account_name: "Group-Jonathan",
  //     account_type: "group",
  //     children: [
  //       {
  //         date: "2022-09-01",
  //         gross_item_sales: 0,
  //         total_payment: 0,
  //         excess_amount: 0,
  //         discounts: 0,
  //         net_item_sales: 0,
  //         service_charges: 0,
  //         net_sales: 0,
  //         sales_tax: 0,
  //         tips: 0,
  //         refunds: 0,
  //         merchant_id: 1,
  //         parent_merchant_id: 1,
  //         linked_merchant_ids: [1],
  //         account_name: "HQ-Jonathan",
  //         account_type: "hq",
  //         children: [
  //           {
  //             date: "third",
  //             gross_item_sales: 0,
  //             total_payment: 0,
  //             excess_amount: 0,
  //             discounts: 0,
  //             net_item_sales: 0,
  //             service_charges: 0,
  //             net_sales: 0,
  //             sales_tax: 0,
  //             tips: 0,
  //             refunds: 0,
  //             merchant_id: 1,
  //             parent_merchant_id: 1,
  //             linked_merchant_ids: [1],
  //             account_name: "HQ-Jonathan",
  //             account_type: "hq",
  //             children: [],
  //           },
  //         ],
  //       },
  //       {
  //         date: "2022-09-01",
  //         gross_item_sales: 0,
  //         total_payment: 0,
  //         excess_amount: 0,
  //         discounts: 0,
  //         net_item_sales: 0,
  //         service_charges: 0,
  //         net_sales: 0,
  //         sales_tax: 0,
  //         tips: 0,
  //         refunds: 0,
  //         merchant_id: 1,
  //         account_name: "Cluster-North Zone",
  //         parent_merchant_id: 1,
  //         account_type: "cluster",
  //         linked_merchant_ids: [],
  //         children: [],
  //       },
  //       {
  //         date: "2022-09-01",
  //         gross_item_sales: 0,
  //         total_payment: 0,
  //         excess_amount: 0,
  //         discounts: 0,
  //         net_item_sales: 0,
  //         service_charges: 0,
  //         net_sales: 0,
  //         sales_tax: 0,
  //         tips: 0,
  //         refunds: 0,
  //         merchant_id: 1,
  //         account_name: "Cluster-North Zone",
  //         parent_merchant_id: 1,
  //         account_type: "cluster",
  //         linked_merchant_ids: [],
  //         children: [],
  //       },
  //       {
  //         date: "2022-09-01",
  //         gross_item_sales: 0,
  //         total_payment: 0,
  //         excess_amount: 0,
  //         discounts: 0,
  //         net_item_sales: 0,
  //         service_charges: 0,
  //         net_sales: 0,
  //         sales_tax: 0,
  //         tips: 0,
  //         refunds: 0,
  //         merchant_id: 13,
  //         parent_merchant_id: 13,
  //         linked_merchant_ids: [13],
  //         account_name: "Outlet-Jonthan",
  //         account_type: "outlet",
  //         children: [],
  //       },
  //     ],
  //   },
  // ];
  const [timeLimit, setTimeLimit] = useState("month");
  const [calDate, setCalDate] = useState(null);
  useEffect(() => {
    dispatch(
      actions?.getSalesData({
        timeLimit: timeLimit,
        dateStart: moment(new Date()).format("YYYY-MM-DD"),
      })
    );
  }, [timeLimit]);

  const startDate = moment(salesData?.return?.prevDate).format("MMM DD, YYYY");
  const endDate = moment(salesData?.return?.limitDate).format("MMM DD, YYYY");
  const todaysDate = moment(new Date()).format("MMM DD, YYYY");

  function getDaysInMonth(month) {
    return new Date(2000, month, 0).getDate();
  }

  function handleLeftClick() {
    // getting prev date
    let year =
      timeLimit === "year"
        ? new Date(startDate).getFullYear() - 1
        : new Date(startDate).getFullYear();
    let month = (() => {
      let monthNumber = new Date(startDate).getMonth() + 1;
      if (timeLimit === "month") {
        if (monthNumber == 1) {
          year--;
          return 12;
        } else {
          return monthNumber - 1;
        }
      } else if (timeLimit === "quarter") {
        if (monthNumber == 3) {
          year--;
          return 12;
        } else if (monthNumber > 3) {
          return monthNumber - 3;
        } else {
          year--;
          return 12 - Math.abs(monthNumber - 3);
        }
      } else return monthNumber;
    })();

    let day = (() => {
      let dayNumber = new Date(startDate)?.getDate();
      if (timeLimit === "week") {
        if (dayNumber - 7 > 0) return dayNumber - 7;
        else {
          month = month - 1;
          return getDaysInMonth(month) - Math.abs(dayNumber - 7);
        }
      } else if (timeLimit === "day") {
        if (dayNumber - 1 > 0) return dayNumber - 1;
        else {
          month = month - 1;
          return getDaysInMonth(month) - 1;
        }
      } else return dayNumber;
    })();
    console.log("aaaaa", month);
    dispatch(
      actions?.getSalesData({
        timeLimit: timeLimit,
        dateStart: `${year}-${month}-${day}`,
      })
    );
  }
  function handleRightClick() {
    // getting prev date
    let year =
      timeLimit === "year"
        ? new Date(startDate).getFullYear() + 1
        : new Date(startDate).getFullYear();
    let month = (() => {
      let monthNumber = new Date(startDate).getMonth() + 1;
      if (timeLimit === "month") {
        if (monthNumber == 12) {
          year++;
          return 1;
        } else {
          return monthNumber + 1;
        }
      } else if (timeLimit === "quarter") {
        if (monthNumber == 12) {
          year++;
          return 1;
        } else if (monthNumber < 9) {
          return monthNumber + 3;
        } else {
          year++;
          return (monthNumber + 3) % 12;
        }
      } else return monthNumber;
    })();

    let day = (() => {
      let dayNumber = new Date(startDate)?.getDate();
      let daysInMonth = getDaysInMonth(month);
      if (timeLimit === "week") {
        if (dayNumber + 7 > daysInMonth) {
          month = month + 1;
          return Math.abs(7 - (daysInMonth - dayNumber));
        } else {
          return dayNumber + 7;
        }
      } else if (timeLimit === "day") {
        if (dayNumber + 1 > daysInMonth) {
          month++;
          return 1;
        } else {
          return dayNumber + 1;
        }
      } else return dayNumber;
    })();
    console.log("aaaaa", month);
    dispatch(
      actions?.getSalesData({
        timeLimit: timeLimit,
        dateStart: `${year}-${month}-${day}`,
      })
    );
  }

  console.log(salesData, "pppppppp");
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />{" "}
        <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
          <div className="container px-0">
            <div className="row mx-0">
              <div className="container px-0">
                <div className="row">
                  <div class="col-md-12">
                    <div className="shadowclass mt-3">
                      <div class="inventory_summary_master">
                        <div class="row-fluid">
                          <div class="col-12">
                            <div class="counts date_new_Cont">
                              <h4 class="event-alert">Select Your Period</h4>

                              <div class="half_new_div d-flex sm-calander">
                                <a
                                  onClick={handleLeftClick}
                                  href="#_"
                                  class="date_label"
                                >
                                  <i class="iconSprites arrow-left"></i>
                                </a>
                                <span class="date-text">
                                  {startDate} - {endDate}
                                </span>
                                <a
                                  onClick={handleRightClick}
                                  href="#_"
                                  class={`date_label ${
                                    endDate == todaysDate ? "hide_div" : ""
                                  }`}
                                >
                                  <i class="iconSprites arrow-right"></i>
                                </a>
                                <span class="clander_icon"></span>
                                <DatePicker
                                  selected={calDate}
                                  onChange={(date) => {
                                    setCalDate(date);
                                    dispatch(
                                      actions?.getSalesData({
                                        timeLimit: timeLimit,
                                        dateStart:
                                          moment(date).format("YYYY-MM-DD"),
                                      })
                                    );
                                  }}
                                />
                              </div>

                              <div class="half_right_div">
                                <ul class="summary_filter add">
                                  <li
                                    onClick={() => setTimeLimit("day")}
                                    class={`${
                                      timeLimit === "day" ? "active" : ""
                                    }`}
                                  >
                                    <a>Day</a>{" "}
                                  </li>
                                  <li
                                    onClick={() => setTimeLimit("week")}
                                    class={`${
                                      timeLimit === "week" ? "active" : ""
                                    }`}
                                  >
                                    <a>Week</a>{" "}
                                  </li>
                                  <li
                                    onClick={() => setTimeLimit("month")}
                                    class={`${
                                      timeLimit === "month" ? "active" : ""
                                    }`}
                                  >
                                    <a>Month</a>{" "}
                                  </li>
                                  <li
                                    onClick={() => setTimeLimit("quarter")}
                                    class={`${
                                      timeLimit === "quarter" ? "active" : ""
                                    }`}
                                  >
                                    <a>Quarter</a>{" "}
                                  </li>
                                  <li
                                    onClick={() => setTimeLimit("year")}
                                    class={`${
                                      timeLimit === "year" ? "active" : ""
                                    }`}
                                  >
                                    <a>Year</a>{" "}
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="accordion inv-accordion Account_list_table singleAccordion "
                  id="accordionPanelsStayOpenExample"
                >
                  <div className="accordion-item">
                    <h2
                      className="accordion-header"
                      id="panelsStayOpen-headingNine"
                    >
                      <button
                        className="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#panelsStayOpen-collapseNine"
                        aria-expanded="true"
                        aria-controls="panelsStayOpen-collapseNine"
                      >
                        <div className="col d-flex align-items-center justify-content-between">
                          <h4 className="event-alert p-0 mb-0">Sales Income</h4>
                        </div>
                      </button>
                    </h2>
                    <div
                      id="panelsStayOpen-collapseNine"
                      className="accordion-collapse collapse show"
                      aria-labelledby="panelsStayOpen-headingNine"
                    >
                      <div className="">
                        <div className="row mx-0">
                          <div className="container px-0">
                            <div className="shadowclass mt-0">
                              <div className="table-responsive sales_right-text">
                                <div
                                  className="accordion accordion-flush"
                                  id="accordionFlushExample"
                                >
                                  <table className="accordion_table checklist-table inventory_table remove-space salesIncomeTable">
                                    <thead>
                                      <tr>
                                        <th> </th>
                                        <th>Account(s)</th>
                                        <th className="text-right">
                                          Business Date
                                        </th>
                                        <th className="text-right">
                                          Gross Item Sales
                                        </th>
                                        <th className="text-right">
                                          Discounts
                                        </th>
                                        <th className="text-right">
                                          Net Item Sales
                                        </th>
                                        <th className="text-right">
                                          Service Charges
                                        </th>
                                        <th className="text-right">
                                          Net Sales
                                        </th>
                                        <th className="text-right">
                                          Sales Tax
                                        </th>
                                        <th className="text-right">Tips</th>
                                        <th className="text-right">Misc</th>
                                        <th className="action-td">Action</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {salesData?.salesIncome?.sales_income?.map(
                                        (firstRow, firstIdx) => (
                                          <>
                                            <tr class="top-view">
                                              <td></td>

                                              <td>
                                                {firstRow.children.length >
                                                  0 && (
                                                  <button
                                                    className="dropdown-green collapsed"
                                                    type="button"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target={`#tableRow_firstRow_${firstIdx}`}
                                                    aria-expanded="false"
                                                    aria-controls={`tableRow_firstRow_${firstIdx}`}
                                                  ></button>
                                                )}
                                                {firstRow?.account_name}
                                              </td>
                                              <td className="text-right">
                                                {firstRow?.date}
                                              </td>
                                              <td className="text-right">
                                                {firstRow?.gross_item_sales}
                                              </td>
                                              <td className="text-right">
                                                {firstRow?.discounts}
                                              </td>
                                              <td className="text-right">
                                                {firstRow?.net_item_sales}
                                              </td>
                                              <td className="text-right">
                                                {firstRow?.service_charges}
                                              </td>
                                              <td className="text-right">
                                                {firstRow?.net_sales}
                                              </td>
                                              <td className="text-right">
                                                {firstRow?.sales_tax}
                                              </td>
                                              <td className="text-right">
                                                {firstRow?.tips}
                                              </td>
                                              <td className="text-right">
                                                {firstRow?.refunds}
                                              </td>

                                              <td class="action-td"></td>
                                            </tr>

                                            <tr
                                              id={`tableRow_firstRow_${firstIdx}`}
                                              className="collapse tr_bg in"
                                            >
                                              <td colspan="12" className="pd0">
                                                <table className="table accordion_table m-0">
                                                  <tbody>
                                                    {firstRow?.children?.map(
                                                      (
                                                        secondRow,
                                                        secondIdx
                                                      ) => {
                                                        return (
                                                          <>
                                                            <tr class="sub_category_row sub_class_row">
                                                              <td class="blnk-td-1"></td>

                                                              <td class="account-name">
                                                                {secondRow
                                                                  .children
                                                                  .length >
                                                                  0 && (
                                                                  <button
                                                                    class="dropdown-green collapsed left0"
                                                                    type="button"
                                                                    data-bs-toggle="collapse"
                                                                    data-bs-target={`#tableRow_secondRow_${
                                                                      firstIdx -
                                                                      secondIdx
                                                                    }`}
                                                                    aria-expanded="false"
                                                                    aria-controls={`tableRow_secondRow_${
                                                                      firstIdx -
                                                                      secondIdx
                                                                    }`}
                                                                  ></button>
                                                                )}
                                                                {
                                                                  secondRow?.account_name
                                                                }
                                                              </td>
                                                              <td class="date-td text-right">
                                                                {
                                                                  secondRow?.date
                                                                }
                                                              </td>

                                                              <td class="currency-td text-right">
                                                                {
                                                                  secondRow?.gross_item_sales
                                                                }
                                                              </td>

                                                              <td class="sales-td text-right">
                                                                {
                                                                  secondRow?.discounts
                                                                }
                                                              </td>

                                                              <td class="currency-td text-right">
                                                                {
                                                                  secondRow?.net_item_sales
                                                                }
                                                              </td>

                                                              <td class="currency-td text-right">
                                                                {
                                                                  secondRow?.service_charges
                                                                }
                                                              </td>

                                                              <td class="currency-td text-right">
                                                                {
                                                                  secondRow?.net_sales
                                                                }
                                                              </td>

                                                              <td class="currency-td text-right">
                                                                {
                                                                  secondRow?.sales_tax
                                                                }
                                                              </td>

                                                              <td class="currency-td text-right">
                                                                {
                                                                  secondRow?.tips
                                                                }
                                                              </td>

                                                              <td className="text-right">
                                                                {
                                                                  secondRow?.refunds
                                                                }
                                                              </td>

                                                              <td class=""></td>
                                                            </tr>

                                                            <tr
                                                              id={`tableRow_secondRow_${
                                                                firstIdx -
                                                                secondIdx
                                                              }`}
                                                              className="collapse tr_bg in sub_category_row sub_class_row"
                                                            >
                                                              <td
                                                                colspan="12"
                                                                className="pd0"
                                                              >
                                                                <table className="table accordion_table m-0">
                                                                  {secondRow?.children?.map(
                                                                    (
                                                                      thirdRow,
                                                                      thirdIdx
                                                                    ) => {
                                                                      return (
                                                                        <>
                                                                          <tr>
                                                                            <td class="blnk-td-1"></td>

                                                                            <td class="account-name">
                                                                              <button
                                                                                class="dropdown-green collapsed left0"
                                                                                type="button"
                                                                                data-bs-toggle="collapse"
                                                                                data-bs-target={`#tableRow_thirdRow_${
                                                                                  firstIdx -
                                                                                  secondIdx -
                                                                                  thirdIdx
                                                                                }`}
                                                                                aria-expanded="false"
                                                                                aria-controls={`tableRow_thirdRow_${
                                                                                  firstIdx -
                                                                                  secondIdx -
                                                                                  thirdIdx
                                                                                }`}
                                                                              ></button>
                                                                              {
                                                                                thirdRow?.account_name
                                                                              }
                                                                            </td>
                                                                            <td class="date-td text-right">
                                                                              {
                                                                                thirdRow?.date
                                                                              }
                                                                            </td>

                                                                            <td class="currency-td text-right">
                                                                              {
                                                                                thirdRow?.gross_item_sales
                                                                              }
                                                                            </td>

                                                                            <td class="sales-td text-right">
                                                                              {
                                                                                thirdRow?.discounts
                                                                              }
                                                                            </td>

                                                                            <td class="currency-td text-right">
                                                                              {
                                                                                thirdRow?.net_item_sales
                                                                              }
                                                                            </td>

                                                                            <td class="currency-td text-right">
                                                                              {
                                                                                thirdRow?.service_charges
                                                                              }
                                                                            </td>

                                                                            <td class="currency-td text-right">
                                                                              {
                                                                                thirdRow?.net_sales
                                                                              }
                                                                            </td>

                                                                            <td class="currency-td text-right">
                                                                              {
                                                                                thirdRow?.sales_tax
                                                                              }
                                                                            </td>

                                                                            <td class="currency-td text-right">
                                                                              {
                                                                                thirdRow?.tips
                                                                              }
                                                                            </td>

                                                                            <td className="text-right">
                                                                              {
                                                                                thirdRow?.refunds
                                                                              }
                                                                            </td>

                                                                            <td class=""></td>
                                                                          </tr>

                                                                          <tr
                                                                            id={`tableRow_thirdRow_${
                                                                              firstIdx -
                                                                              secondIdx -
                                                                              thirdIdx
                                                                            }`}
                                                                            className="collapse tr_bg in sub_category_row sub_class_row"
                                                                          >
                                                                            <td
                                                                              colspan="12"
                                                                              className="pd0"
                                                                            >
                                                                              <table className="table accordion_table m-0">
                                                                                <tr>
                                                                                  <td class="blnk-td-1 ps-3"></td>

                                                                                  <td class="account-name">
                                                                                    Cluster-Central
                                                                                  </td>
                                                                                  <td class="date-td text-right">
                                                                                    02-May-2022
                                                                                  </td>

                                                                                  <td class="currency-td text-right">
                                                                                    $359.51
                                                                                  </td>

                                                                                  <td class="sales-td text-right">
                                                                                    ($29.70)
                                                                                  </td>

                                                                                  <td class="currency-td text-right">
                                                                                    $329.81
                                                                                  </td>

                                                                                  <td class="currency-td text-right">
                                                                                    $32.43
                                                                                  </td>

                                                                                  <td class="currency-td text-right">
                                                                                    $362.24
                                                                                  </td>

                                                                                  <td class="currency-td text-right">
                                                                                    $25.37
                                                                                  </td>

                                                                                  <td class="currency-td text-right">
                                                                                    $0.00
                                                                                  </td>

                                                                                  <td className="text-right">
                                                                                    $0.00{" "}
                                                                                  </td>

                                                                                  <td class=""></td>
                                                                                </tr>
                                                                              </table>
                                                                            </td>
                                                                          </tr>
                                                                        </>
                                                                      );
                                                                    }
                                                                  )}
                                                                </table>
                                                              </td>
                                                            </tr>
                                                          </>
                                                        );
                                                      }
                                                    )}
                                                  </tbody>
                                                </table>
                                              </td>
                                            </tr>
                                          </>
                                        )
                                      )}

                                      {/*  */}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* <div className="row justify-content-end align-items-center my-3">
                    <div className="col-md-6 align-right">
                      <div className="field text-right">
                        <button
                          class="btn green-btn-revert add-plus addSp mx-0"
                          id="addCount"
                          type="button"
                        >
                          <i class="i-icon"> </i> Add Other Income
                        </button>
                      </div>
                    </div>
                  </div> */}
                </div>
                <div className="accordion-item">
                  <h2
                    className="accordion-header"
                    id="panelsStayOpen-headingNine2"
                  >
                    <button
                      className="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#panelsStayOpen-collapseNine2"
                      aria-expanded="true"
                      aria-controls="panelsStayOpen-collapseNine2"
                    >
                      <div className="col d-flex align-items-center justify-content-between">
                        <h4 className="event-alert p-0 mb-0">Other Income</h4>
                      </div>
                    </button>
                  </h2>
                  <div
                    id="panelsStayOpen-collapseNine2"
                    className="accordion-collapse collapse show"
                    aria-labelledby="panelsStayOpen-headingNine2"
                  >
                    <div className="row mx-0 pendingShiftMs">
                      <div className="container px-0">
                        <div className="shadowclass mt-0">
                          <div className="row justify-content-between align-items-center mx-0">
                            <div className="col-lg-4 col-md-5 px-0 mb-3 mb-sm-0"></div>

                            <div className="col-sm-7 col-12 align-right px-0">
                              <div className="field text-right">
                                <button
                                  onClick={() =>
                                    history.push("/finance/sales/add")
                                  }
                                  class="btn green-btn-revert add-plus addSp mx-0"
                                  id="addCount"
                                  type="button"
                                >
                                  <i class="i-icon"> </i> Add Other Income
                                </button>
                              </div>
                            </div>
                          </div>

                          <div className="table-responsive">
                            <table className="checklist-table remove-space ingredTable">
                              <thead>
                                <tr>
                                  <th className="">Account</th>
                                  <th className="">Income Group</th>
                                  <th className="">Transaction Amount</th>
                                  <th className="">Transaction ID</th>
                                  <th className="">Transaction Date</th>
                                  <th className="">Invoice ID</th>
                                  <th className="">Description</th>
                                  <th className="">Income Account</th>
                                  <th className="">Receiving Account</th>
                                  <th className="">Action </th>
                                </tr>
                              </thead>
                              <tbody>
                                {salesData?.other_income?.map((el) => (
                                  <tr>
                                    <td className="">
                                      {el?.merchant?.account_name}
                                    </td>
                                    <td className="">
                                      {el?.income_group_id ?? "null"}
                                    </td>
                                    <td className="">
                                      {el?.transaction_amount ?? "null"}
                                    </td>
                                    <td className="">
                                      {el?.transaction_id ?? "null"}
                                    </td>
                                    <td className="">
                                      {el?.transaction_date ?? "null"}
                                    </td>
                                    <td className="">
                                      {el?.invoice_id ?? "null"}
                                    </td>
                                    <td className="">
                                      {el?.description ?? "null"}
                                    </td>
                                    <td className="">
                                      {el?.finance_account_other ?? "null"}
                                    </td>
                                    <td className="">
                                      {el?.finance_account ?? "null"}
                                    </td>
                                    <td className="">
                                      <a
                                        class="circle_icon"
                                        onClick={() => {
                                          dispatch(
                                            actions.saveOtherIncomeDataOptions(
                                              el
                                            )
                                          );
                                          history.push({
                                            pathname: "/finance/sales/add",
                                            state: {
                                              type: "edit",
                                              id: el.id,
                                            },
                                          });
                                        }}
                                      >
                                        <i class="iconSprites edit-icon">
                                          <div class="tooltip-sm"> Edit </div>
                                        </i>
                                      </a>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default Sales;
